import React,{useState} from 'react';
import {BrowserRouter as Router,Routes,Route} from 'react-router-dom';
import {AnimatePresence} from 'framer-motion';
import IntroPage from './components/IntroPage';
import QuizPage from './components/QuizPage';
import ResultsPage from './components/ResultsPage';
import ResultsPreviewPage from './components/ResultsPreviewPage';
import './App.css';

function App() {
  const [participantData,setParticipantData]=useState({name:'',email:'',consent:false});
  const [quizResults,setQuizResults]=useState(null);

  return (
    <div className="min-h-screen bg-midnight-blue font-poppins">
      <Router>
        <AnimatePresence mode="wait">
          <Routes>
            <Route
              path="/"
              element={(
                <IntroPage
                  participantData={participantData}
                  setParticipantData={setParticipantData}
                />
              )}
            />
            <Route
              path="/quiz"
              element={(
                <QuizPage
                  participantData={participantData}
                  setParticipantData={setParticipantData}
                  setQuizResults={setQuizResults}
                />
              )}
            />
            <Route
              path="/results"
              element={(
                <ResultsPage
                  participantData={participantData}
                  quizResults={quizResults}
                />
              )}
            />
            <Route path="/preview-results" element={<ResultsPreviewPage />} />
          </Routes>
        </AnimatePresence>
      </Router>
    </div>
  );
}

export default App;